import { useLocation } from 'react-router-dom';
import { usePageTransition } from '../context/TransitionContext.jsx';
import { posts } from '../data/blog/index.js';
import '../assets/css/src/blog.css';

export default function Blog() {
  const { navigateTo } = usePageTransition();
  const location = useLocation();

  function handleClick(e, to) {
    e.preventDefault();
    if (location.pathname === to) return;
    navigateTo(to);
  }

  return (
    <section className="page-content">
      <ul className="blog-list">
        {posts.filter((p) => p.published !== false).map((post) => (
          <li key={post.slug} className="blog-card">
            
            {post.image && (
              <img src={post.image} alt={post.title} className="blog-card-image" />
            )}
            <a
              href={`/blog/${post.slug}`}
              className="blog-card-link"
              onClick={(e) => handleClick(e, `/blog/${post.slug}`)}
            >
              <h2 className="blog-card-title">{post.title}</h2>
            </a>
            <p className="blog-excerpt">{post.excerpt}</p>
            <time className="blog-date">
              {new Date(post.date).toLocaleDateString('en-CA', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              })}
            </time>
          </li>
        ))}
      </ul>
    </section>
  );
}
